import * as React from 'react';
import { cn } from '@/shared/lib/cn';
import { Tooltip } from '@/shared/ui/Tooltip/Tooltip';
import styles from './Button.module.css';

export type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'ghost'
  | 'ghost-danger'
  | 'outline'
  | 'destructive';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  iconOnly?: boolean;
  tooltip?: React.ReactNode;
  tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
}

/**
 * Button — Luma neutral. Без иконочной слотовой логики:
 * иконки кладутся как children (gap уже выставлен в .button).
 * С пропом `tooltip` кнопка получает стилевой тултип.
 *
 * @use любое действие-кнопка. Вариант выбирается по смыслу: `destructive` — главное действие в диалоге удаления, `ghost-danger` — снятие связи в строке списка.
 */
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = 'md', fullWidth, iconOnly, className, type = 'button', tooltip, tooltipSide, ...rest },
  ref,
) {
  const btn = (
    <button
      ref={ref}
      type={type}
      className={cn(
        styles.button,
        styles[`size-${size}`],
        styles[`variant-${variant}`],
        fullWidth && styles.fullWidth,
        iconOnly && styles.iconOnly,
        className,
      )}
      {...rest}
    />
  );

  return tooltip ? (
    <Tooltip content={tooltip} side={tooltipSide}>
      {btn}
    </Tooltip>
  ) : (
    btn
  );
});
